<script>
import { BModal } from 'bootstrap-vue'
import Relations from "@core/components/common/changelog/Relations.vue";

export default {
    name: 'RelationsModal',
    components: {Relations, BModal},
    props: {
        label: {
            default() {
                return this.$t('Component(ChangeLog):relations-label');
            }
        },
        relations: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    methods: {
        show() {
            this.$refs['change-log-relations-modal'].show();
        },
    },
}
</script>

<template>
    <b-modal
        ref="change-log-relations-modal"
        cancel-variant="outline-secondary"
        body-class="p-0"
        hide-header
        size="lg"
        :ok-title="$t('Component(Button):close')"
        centered
        ok-only
    >
        <Relations
            :label="label"
            :relations="relations"
        />

    </b-modal>
</template>
